import { Typography, Box } from '@mui/material';
import ExcelUploadSection from './ExcelUploadSection';

const DocsSubjects = () => {
  return (
    <Box>
      <Typography variant="h1" gutterBottom>
        Subjects
      </Typography>

      <Typography variant="body1" paragraph>
        Subjects represent the different courses or topics that are taught in
        your institution. Each subject needs to be defined before timetable
        generation to associate it with teachers and student groups.
      </Typography>

      <Typography variant="h2" gutterBottom>
        Adding a Subject
      </Typography>

      <ExcelUploadSection />

      <Typography variant="body1" paragraph>
        To add a new subject, follow these steps:
      </Typography>
      <ul>
        <li>
          <Typography variant="body1">
            Navigate to the <strong>Subjects</strong> section in the dashboard.
          </Typography>
        </li>
        <li>
          <Typography variant="body1">
            Click on <strong>Add</strong>.
          </Typography>
        </li>
        <li>
          <Typography variant="body1">
            Select the department to which the subect belongs to.
          </Typography>
        </li>
        <li>
          <Typography variant="body1">
            Enter the subject code (e.g., Maths-101, PhysicsXII, CS-301).
          </Typography>
        </li>
        <li>
          <Typography variant="body1">
            Select the subject type to link it with a particular classroom type.
          </Typography>
        </li>
        <li>
          <Typography variant="body1">
            Optionally, specify a subject name in the description for reference.
          </Typography>
        </li>
        <li>
          <Typography variant="body1">
            Enter the number of sessions/classes needed for the subject every
            week.
          </Typography>
        </li>
        <li>
          <Typography variant="body1">
            Enter the number of time slots needed for each session/class.
          </Typography>
        </li>
        <li>
          <Typography variant="body1">
            Click <strong>Save</strong> to add the subject.
          </Typography>
        </li>
      </ul>

      <Typography variant="h2" gutterBottom>
        Managing Subjects
      </Typography>
      <Typography variant="body1" paragraph>
        You can manage subjects after adding them:
      </Typography>
      <ul>
        <li>
          <Typography variant="body1">
            <strong>Editing:</strong> Click on the edit(pencil) button to modify
            subject details.
          </Typography>
        </li>
        <li>
          <Typography variant="body1">
            <strong>Deleting:</strong> Click on the edit(pencil) button and
            select delete if it is no longer needed.
          </Typography>
        </li>
      </ul>
    </Box>
  );
};

export default DocsSubjects;
